import React, {memo} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import {CONTACT_EMAIL} from '@/constants/urls';
import {COUNTRY_FLAGS as FLAGS} from '@/constants/images';
import styles from './AppBar.module.scss';

const inlineIconStyle = {display: 'inline-block', verticalAlign: 'middle'} as const;

const EmailIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={inlineIconStyle}>
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
);

const LocalPhoneIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={inlineIconStyle}>
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
    </svg>
);

const LanguageIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={inlineIconStyle}>
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
    </svg>
);

const AppBar = () => {
    return (
        <div className={styles.grid}>
            <div className={`${styles.item} ${styles.left}`}>
                <div className={`header-mail ${styles.headerMail}`}>
                    <div className={`header-info ${styles.headerInfo}`}>
                        <Link href={`mailto:${CONTACT_EMAIL}`} className="menu-links" target="_blank">
                            <p className={`email-sub font-regular-text ${styles.infoText}`}>
                                <EmailIcon />
                                {CONTACT_EMAIL}
                            </p>
                        </Link>
                    </div>
                    <div className={`header-info header-phone-section ${styles.headerInfo} ${styles.phoneSection}`}>
                        <Link href="tel:1-708-515-4004" className="menu-links">
                            <p className={`phone-sub font-regular-text ${styles.infoText}`}>
                                <LocalPhoneIcon />
                                +1-708-515-4004
                            </p>
                        </Link>
                    </div>
                </div>
            </div>
            <div className={`flag-main-section ${styles.item} ${styles.right} ${styles.flagMainSection}`}>
                <div className={`flag-inner-section ${styles.flagInnerSection}`}>
                    <div className={`company-presence ${styles.companyPresence}`}>
                        <LanguageIcon />
                        <p className={`company-presence-content font-regular-text ${styles.presenceText}`}>Our Global Presence : </p>
                    </div>
                    <div className={`flag-wrapper ${styles.flagWrapper}`}>
                        <div className="flag-icon">
                            <Image src={FLAGS.usa} alt="USA" height={24} width={24} loading="eager" unoptimized />
                        </div>

                        <div className="flag-icon">
                            <Image src={FLAGS.uk} alt="UK" height={24} width={24} loading="eager" unoptimized />
                        </div>

                        <div className="flag-icon">
                            <Image src={FLAGS.canada} alt="Canada" height={24} width={24} loading="eager" unoptimized />
                        </div>
                        <div className="flag-icon">
                            <Image src={FLAGS.india} alt="India" height={24} width={24} loading="eager" unoptimized />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(AppBar);
